import { Component, EventEmitter, forwardRef, inject, input, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'work-ui-checkbox',
  standalone: true,
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  host: {
    '[class.border-none]': 'readonlyNoBorders',
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
  imports: [TranslateModule, NgClass],
})
export class CheckboxComponent implements OnInit, ControlValueAccessor, Validator {
  @Input() checked = false;
  @Input() name = '';
  @Input() label = '';
  @Input() labelBold = false;
  @Input() description = '';
  @Input() disabled = false;
  @Input() readonly = false;
  @Input() readonlyNoBorders = false;
  @Input() required = false;
  @Input() formControlName = '';
  @Input() noMargin = false;
  @Input() cardStyle = false;
  public stopPropagation = input<boolean>(false);
  @Output() checkedChange = new EventEmitter<boolean>();
  private controlContainer = inject(ControlContainer, { optional: true });
  private formControl: FormControl | undefined;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: any = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched: any = () => {};

  ngOnInit() {
    this.setOptionsFromFormControl();
  }

  /**
   * Give the Checkbox the correct value on click
   */
  toggleCheckbox(event: Event): void {
    if (this.stopPropagation() && event) {
      event.stopPropagation();
    }
    this.checked = !this.checked;
    this.onChange(this.checked);
    this.onTouched();
    this.checkedChange.emit(this.checked);
  }

  writeValue(obj: any): void {
    this.checked = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  validate(): ValidationErrors | null {
    return this.required && this.checked === undefined ? { required: true } : null;
  }

  setOptionsFromFormControl() {
    if (this.controlContainer && this.formControlName) {
      this.formControl = this.controlContainer.control?.get(this.formControlName) as FormControl;
      if (this.formControl) {
        if (this.formControl.value) {
          this.checked = this.formControl.value;
        }
        if (this.formControl.validator) {
          const validator = this.formControl.validator({} as AbstractControl);
          this.required = validator && validator['required'];
        }
      }
    }
  }
}
